import axios from 'axios'

const axiosinstance = axios.create()
axiosinstance.interceptors.request.use(
  function (config) {
    config.baseURL = process.env.VUE_APP_WEBAPI_ENDPOINT + 'api/'
    config.withCredentials = false
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default {
  get (url, request) {
    return axiosinstance.get(url, { params: request })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  },
  post (url, request) {
    return axiosinstance.post(url, request)
      .then((response) => Promise.resolve(response))
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  getPDF (url, request) {
    return axiosinstance.get(url, { responseType: 'arraybuffer', params: request })
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error))
  }
}
